module.exports = __webpack_public_path__ + "static/media/traffic-no.4ec81564.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/traffic-no.svg
// module id = 900
// module chunks = 0